import { FC, ReactNode } from 'react';
import { ReloadOutlined } from '@ant-design/icons';

import type { UploadTranslations } from '../types';
import styles from '../FileUploader.module.scss';

interface ErrorContentProps {
    subtitle: ReactNode;
    translations: UploadTranslations;
    onRetry: () => void;
}

export const ErrorContent: FC<ErrorContentProps> = ({
    subtitle,
    translations,
    onRetry,
}) => {
    return (
        <div className={styles.errorMessage}>
            <div className={styles.errorTitle}>
                {translations.uploadFailedTitle}
            </div>
            <div className={styles.errorText}>
                {subtitle ?? translations.uploadFailedCommon}
            </div>
            <button
                type="button"
                className={styles.errorRetry}
                onClick={onRetry}
            >
                <ReloadOutlined className={styles.errorRetryIcon} />
                {translations.tryAgain}
            </button>
        </div>
    );
};
